import { render, staticRenderFns } from "./AkSkDownload.vue?vue&type=template&id=395ddb87"
import script from "./AkSkDownload.vue?vue&type=script&lang=js"
export * from "./AkSkDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports